import { render } from "./Conversations.vue?vue&type=template&id=48dcc59b&scoped=true"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"

import "./Conversations.vue?vue&type=style&index=0&id=48dcc59b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dcc59b"]])

export default __exports__